import type { LoggerAdapter } from './logger-adapter.interface';

export class EnvironmentAdapter implements LoggerAdapter {
  public static readonly ENV_KEY = 'FLUX_DEBUG';

  public getPattern(): string | null {
    if (typeof process === 'undefined' || !process.env) {
      return null;
    }

    const exactMatch = process.env[EnvironmentAdapter.ENV_KEY];
    if (exactMatch) {
      return exactMatch;
    }

    return null;
  }

  public enable(pattern?: string): void {
    if (typeof process === 'undefined' || !process.env) {
      return;
    }

    process.env[EnvironmentAdapter.ENV_KEY] = pattern ?? '*';
  }

  public disable() {
    if (typeof process === 'undefined' || !process.env) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete process.env[EnvironmentAdapter.ENV_KEY];
  }
}
